import { UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE } from '@/common/actions/update';
import { useMutation } from '@apollo/client';
import { Box, Button, Checkbox, SelectSingle, Typography } from '@servicepipe/ui-components';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

const LANGUAGE_OPTIONS = [
  { value: 'EN', label: 'EN' },
  { value: 'RU', label: 'RU' },
];

export const LanguageSettings = ({ languageData, userId }) => {
  const initialized = useRef(false);
  const [lang, setLang] = useState('');
  const [availableLangs, setAvailableLangs] = useState([]);

  const [updateEmployee, { loading }] = useMutation(UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE, {
    onCompleted: () => toast.success('Success'),
    onError: (error) => toast.error(error.message),
  });

  useEffect(() => {
    if (!languageData || initialized.current) {
      return;
    }

    setLang(languageData.lang);
    setAvailableLangs(languageData.availableLangs || []);
    initialized.current = true;
  }, [languageData]);

  const toggleLang = (langCode) => {
    const containsLang = availableLangs.includes(langCode);

    if (containsLang && availableLangs.length <= 1) {
      toast.error('At least one language must be selected');
      return;
    }

    const nextLangs = containsLang
      ? availableLangs.filter((item) => item !== langCode)
      : [...availableLangs, langCode];

    setAvailableLangs(nextLangs);

    if (!nextLangs.includes(lang)) {
      setLang(nextLangs[0] || '');
    }
  };

  const handleSave = () => {
    if (availableLangs.length === 0) {
      toast.error('At least one language must be selected');
      return;
    }

    updateEmployee({
      variables: {
        id: userId,
        lang,
        availableLangs,
      },
    });
  };

  if (!languageData) {
    return null;
  }

  const langOptions = LANGUAGE_OPTIONS.filter((option) => availableLangs.includes(option.value));
  const selectedLang = langOptions.find((option) => option.value === lang) || null;

  return (
    <Box direction="column" gap="20px" width="550px">
      <Typography variant="h6">Language Settings</Typography>

      <Typography variant="bodyMR">Default language:</Typography>

      <Box maxWidth="80px">
        <SelectSingle
          value={selectedLang}
          onChange={(option) => setLang(option?.value || '')}
          options={langOptions}
        />
      </Box>

      <Typography variant="bodyMR">Available languages:</Typography>

      <Box direction="column" gap="8px">
        <Checkbox
          label="English (EN)"
          checked={availableLangs.includes('EN')}
          onChange={() => toggleLang('EN')}
        />
        <Checkbox
          label="Russian (RU)"
          checked={availableLangs.includes('RU')}
          onChange={() => toggleLang('RU')}
        />
      </Box>

      <Box justify="right" width="100%">
        <Button variant="solid" color="accent" isLoading={loading} onClick={handleSave}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
